import React from 'react';

export const BodyFootIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M92.9609 77.2617C91.0294 68.7273 88.3922 68.7437 87.7441 57.373C87.0961 46.0024 85.6445 31.4453 68.9453 31.4453C61.3281 31.4453 51.3144 35.8611 50.7324 52.0508C48.6816 66.1133 35.8887 70.166 28.4026 73.3438C25.9245 74.3957 21.6645 76.3672 19.1895 76.3672C17.7246 76.3672 16.7266 75.4082 15.0391 75.4395C8.98438 75.4395 6.39648 81.0547 6.39648 85.0586C6.39648 89.0625 9.11849 93.5117 15.3713 93.5117C19.6843 93.5117 71.2082 93.5117 80.6172 93.5117C90.0261 93.5117 94.8924 85.7962 92.9609 77.2617Z"
        fill="#FFC83D"
      />
      <path
        d="M72.8516 71.875C67.3828 71.875 65.8529 66.0156 65.5273 62.5C65.5273 61.1328 64.6875 59.2773 62.5 59.2773C60.3125 59.2773 59.5215 60.791 59.5215 62.1582C59.5215 67.1387 62.0117 75 72.8516 75C77.8809 75 80.9082 72.4121 81.4453 69.3359C80.5176 70.2637 78.3203 71.875 72.8516 71.875Z"
        fill="#D67D00"
      />
      <path
        d="M89.2189 90.5762H8.35522C9.8103 92.3019 12.1108 93.5117 15.3715 93.5117H80.6173C84.1744 93.5117 87.0822 92.409 89.2189 90.5762Z"
        fill="#D67D00"
      />
    </svg>
  );
};
